// Copyright (c) 2019 Deere & Company

export const bindOnConfirmActions = (audit, actions) => ({
    skipAudit: actions.skipAudit.bind(null, audit)
});

export const confirmationModalMap = (action, onClose, confirmActions) => ({
    SKIP_AUDIT: {
        confirmMessage: 'CONFIRM_SKIP_AUDIT',
        isOpen: true,
        onClose,
        onConfirm: () => {

            confirmActions.skipAudit();
            onClose();

        },
        title: 'SKIP_AUDIT'
    }
}[action.id]);



// WEBPACK FOOTER //
// ./src/tcsm/audits/services/confirmation-modal-map.js